import { createStore, combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import {PersistConfig} from "redux-persist/es/types";
import reduxStorage from 'redux-persist/lib/storage';

import {loader, session} from './reducers';

const rootReducer = combineReducers({
    loader,
    session
});

export type RootState = ReturnType<typeof rootReducer>;

const persistConfig: PersistConfig<any> = {
    key: 'root',
    storage: reduxStorage,
    whitelist: ['session'],
};

const persistedReducer = persistReducer<RootState>(persistConfig, rootReducer);

export const store = createStore(persistedReducer);
export const persist = persistStore(store);
